import { render, staticRenderFns } from "./ioc-forms.vue?vue&type=template&id=d99fe996&"
import script from "./ioc-forms.vue?vue&type=script&lang=js&"
export * from "./ioc-forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports